import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, node, number, string } from 'prop-types'

function PaginationLink({
  page,
  href,
  label,
  onClick,
  children,
  isCurrent = false,
  isDisabled = false,
}) {
  const className = classnames(
    'listing-pagination-links__link',
    'cgt-body-base',
    isCurrent && 'listing-pagination-links__link--current',
    isDisabled && 'listing-pagination-links__link--disabled'
  )

  if (isDisabled) {
    return (
      <li className="listing-pagination-links__item">
        <span className={className} aria-disabled="true" aria-label={label}>
          {children}
        </span>
      </li>
    )
  }

  return (
    <li className="listing-pagination-links__item">
      <a
        href={href}
        className={className}
        aria-label={label}
        aria-current={isCurrent ? 'page' : undefined}
        onClick={(event) => onClick(event, page)}
      >
        {children}
      </a>
    </li>
  )
}

PaginationLink.propTypes = {
  page: number.isRequired,
  href: string.isRequired,
  label: string.isRequired,
  onClick: func.isRequired,
  children: node.isRequired,
  isCurrent: bool,
  isDisabled: bool,
}

export default PaginationLink
